import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VIcon,{class:_vm.noPos ? '' : 'help-icon',attrs:{"disabled":_vm.disabled,"color":_vm.computedColor},on:{"click":function($event){return _vm.iconClicked($event)}}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }